import React, { useState } from 'react';
import styled from 'styled-components';
import { gspx } from '@rsos/capstone';
import Box from '@rsos/components/capstone/base/Box';
import Button from '@rsos/components/capstone/base/Button';
import Text from '@rsos/components/capstone/base/Text';
import { ERAShowIcon, ERAHideIcon } from '@rsos/assets/icons';
import InfoTooltip from './InfoTooltip';

const ButtonText = styled(Text)`
  letter-spacing: normal;
`;

const Title = styled.strong`
  display: inline-flex !important;
  align-items: center !important;
  svg {
    margin-left: 10px;
  }
`;

const CustomActionableButton = props => {
  const {
    children,
    ownData,
    schema,
    path = [],
    onClick,
    cardBodyRef,
    irpVersion,
  } = props;
  const { title, description } = schema;

  const [isDisplayed, setIsDisplayed] = useState(false);

  return (
    <div className={`default-type-object depth-${path.length}`}>
      <div className="default-type-object-title">
        <Title className="default-type-title">
          {title}
          <InfoTooltip cardBodyRef={cardBodyRef} />
        </Title>

        {description && (
          <div className="default-type-description">{description}</div>
        )}
      </div>
      <Box width="100%" my={10}>
        <Button
          btnType="tertiary"
          noMargin
          onClick={() => {
            setIsDisplayed(isDisplayed => !isDisplayed);
            onClick(
              isDisplayed
                ? null
                : {
                    data: ownData,
                    schema,
                  },
            );
            (async () => {
              try {
                const event = isDisplayed ? 'era-toggle-off' : 'era-toggle-on';
                gspx.trackCustomEvent('Ellington', {
                  irpVersion,
                  name: event,
                  Category: 'Ellington-ADR',
                  'Launched date': new Date(),
                });
              } catch {
                /* fail without crashing */
              }
            })();
          }}
        >
          <Box horizontal align="center" justify="center">
            {isDisplayed ? (
              <ERAHideIcon viewboxHeight={80} height={14} />
            ) : (
              <ERAShowIcon height={16} />
            )}
            <ButtonText size="small">
              {isDisplayed ? 'Hide on Map' : 'Display on Map'}
            </ButtonText>
          </Box>
        </Button>
      </Box>
      <div className="default-type-object-children">{children}</div>
    </div>
  );
};

export default CustomActionableButton;
